export const PlanManagerEvents = {
  GetPlanStartAndEnd: 'PlanManager.GetPlanStartAndEnd',
  PlanStartAndEndReturned: 'PlanManager.PlanStartAndEndReturned',

  GetCurrentPlans: 'PlanManager.GetCurrentPlans',
  CurrentPlansReturned: 'PlanManager.CurrentPlansReturned',

  GetCoverageLeft: 'PlanManager.GetCoverageLeft',
  CoverageLeftReturned: 'PlanManager.CoverageLeftReturned',

  UpdatePlan: 'PlanManager.UpdatePlan',
  UpdatePlanCompleted: 'PlanManager.UpdatePlanCompleted',
}
